import React from "react";

function Users(props) {
  return <div>Users List</div>;
}

export default Users;
